// 提供支付宝小程序webview通信能力
import { resolveWithError } from 'root/common/util/promiseHelper';

/**
 * 支付宝webview通信
 */
export function getMessageByAliMiniWebView(name, data = {}) {
    // 通信唯一id，保证接收到的响应为本次发起的请求
    const key = Number(
        Math.random()
            .toString()
            .substr(2, 8)
    ).toString(36);
    return new Promise((resolve, reject) => {
        window.my.getEnv(() => {
            window.my.postMessage({ name, key, ...data });
            window.my.onMessage = e => {
                if (e.name === name && e.key === key) {
                    if (e.code === 1) {
                        resolve(e.data);
                    } else {
                        reject(e.data);
                    }
                }
            };
        });
    });
}

/**
 * 获取支付宝小程序信息
 */
export async function getAliMiniAppInfo() {
    return getMessageByAliMiniWebView('getAppInfo');
}

/**
 * 获取支付宝小程序指定信息
 * @param {String} key 取值：aliUserId | appId | appName | channelId
 */
export async function getAliMiniAppInfoByKey(key) {
    const info = await getAliMiniAppInfo();
    return info[key];
}

/**
 * 拉起支付宝小程序订阅消息授权
 * @param {Array} entityIds 消息模版id集合
 * @returns {Promise<[Error|null,T|null]>}
 */
export function requestSubscribeMessage(entityIds) {
    return resolveWithError(getMessageByAliMiniWebView('requestSubscribeMessage', { entityIds }));
}

/**
 * 拉起支付宝小程序订单消息授权
 * @returns {Promise<[Error|T|null,T|null]>}
 */
export function requestSubscribeOrderMessage() {
    return resolveWithError(getMessageByAliMiniWebView('getAuthCode', { scopes: ['order_service'] }));
}
